<template>
  <div class="nx-url-selector">
    <nx-url-selector
      v-validate:value="urlValidation"
      :data-vv-name="name"
      :data-vv-scope="scope"
      :data-vv-as="label"
      :disabled="disabled"
      :label="label"
      :required="required"
      :value="computedValue"
      :suggest-context="suggestContext"
      data-vv-validate-on="input|blur"
      data-vv-value-path="value"
      v-bind="$attrs"
      @blur="onBlur"
      @focus="onFocus"
      @input="onInput"
    />
  </div>
</template>

<script>
import FormElement from '@/modules/form/mixins/form-element';
import NxUrlSelector from '@/modules/url/UrlSelector';
import get from 'lodash/get';

export default {
  name: 'NxUrlFormSelector',
  components: {
    NxUrlSelector,
  },
  mixins: [FormElement],
  inject: {
    $getParentEditor: {
      default: null,
    },
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      lastValue: {},
    };
  },
  computed: {
    urlValidation() {
      if (typeof this.validation === 'object') {
        return { ...this.validation, nx_valid_url: true };
      }
      if (typeof this.validation === 'string') {
        return `${this.validation}, nx_valid_url`;
      }
      return 'nx_valid_url';
    },
    computedValue() {
      return this.value || this.lastValue;
    },
    suggestContext() {
      return {
        entity: get(this.$getParentEditor(), 'entity', null),
        entityId: get(this.$getParentEditor(), 'id', null),
        field: this.name,
      };
    },
  },
  mounted() {
    this.lastValue = this.value || {};
  },
  methods: {
    onInput(value) {
      this.lastValue = value;
      if (!value || !value.path) {
        value = null;
      }

      this.$parentForm.updateField(this.name, value);
      this.$emit('input', value);
    },
    onBlur(blurValue) {
      this.flags.focused = false;
      this.$emit('blur', blurValue);
    },
  },
};
</script>
